import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@clerk/clerk-react'
import { api } from '../lib/api'

export function useVoiceProfile() {
  const { getToken } = useAuth()
  const queryClient = useQueryClient()

  const {
    data: profile,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['voiceProfile'],
    queryFn: async () => {
      const token = await getToken()
      return api.getVoiceProfile(token)
    },
  })

  const setProfileMutation = useMutation({
    mutationFn: async ({
      phoneNumber,
      pin,
    }: {
      phoneNumber: string
      pin: string
    }) => {
      const token = await getToken()
      return api.setVoiceProfile(phoneNumber, pin, token)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voiceProfile'] })
    },
  })

  const deleteProfileMutation = useMutation({
    mutationFn: async () => {
      const token = await getToken()
      return api.deleteVoiceProfile(token)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voiceProfile'] })
    },
  })

  const unlockMutation = useMutation({
    mutationFn: async () => {
      const token = await getToken()
      return api.unlockVoiceProfile(token)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voiceProfile'] })
    },
  })

  return {
    profile,
    isLoading,
    error,
    setProfile: setProfileMutation.mutateAsync,
    isSettingProfile: setProfileMutation.isPending,
    setProfileError: setProfileMutation.error,
    deleteProfile: deleteProfileMutation.mutateAsync,
    isDeletingProfile: deleteProfileMutation.isPending,
    unlockProfile: unlockMutation.mutateAsync,
    isUnlocking: unlockMutation.isPending,
  }
}
